var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classNames from "classnames";
import React from "react";
import { QuiSegmentedControlContext } from "./QuiSegmentedControlContext.js";
export function QuiSegmentedControl(_a) {
    var { disabled, size, className, invalid, fullWidth, value, onChange, children } = _a, otherProps = __rest(_a, ["disabled", "size", "className", "invalid", "fullWidth", "value", "onChange", "children"]);
    const cn = classNames(`qui-segmented-control`, `qui-segmented-control--${size !== null && size !== void 0 ? size : "sm"}`, {
        "qui-invalid": invalid,
        "qui-disabled": disabled,
        "qui-segmented-control--full-width": fullWidth,
    }, className);
    return (React.createElement(QuiSegmentedControlContext.Provider, { value: { selectedValue: value, onChange: onChange, size: size !== null && size !== void 0 ? size : "md", disabled: disabled !== null && disabled !== void 0 ? disabled : false } },
        React.createElement("div", Object.assign({ role: "group", className: cn }, otherProps, { "aria-disabled": disabled, "aria-invalid": invalid }), children)));
}
QuiSegmentedControl.displayName = "QuiSegmentedControl";
